import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { ProductCategoriesService } from 'src/services/data/product-categories.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createProductCategory, createProductCategoryFailure, createProductCategorySuccess, loadProductCategories, loadProductCategoriesFailure, loadProductCategoriesSuccess, updateProductCategory, updateProductCategoryFailure, updateProductCategorySuccess } from './product-category.actions'

@Injectable()
export class ProductCategoryEffects {
  private actions$ = inject(Actions)
  private ProductCategories = inject(ProductCategoriesService)
  private toaster = inject(ToasterService)


  loadProductCategories$ = createEffect(() => this.actions$.pipe(
    ofType(loadProductCategories),
    switchMap(() =>
      from(this.ProductCategories.getProductCategories()).pipe(
        map(productCategories => loadProductCategoriesSuccess({ productCategories })),
        catchAndLog(this.toaster, 'Unable to fetch productCategories', loadProductCategoriesFailure)))))

  createProductCategory$ = createEffect(() => this.actions$.pipe(
    ofType(createProductCategory),
    tap(() => this.toaster.progress('Creating product category...')),
    switchMap(action =>
      from(this.ProductCategories.create(action.productCategory)).pipe(
        map(productCategory => createProductCategorySuccess({ productCategory })),
        tap(() => this.toaster.success('Product category created successfully.')),
        catchAndLog(this.toaster, 'Unable to create product category', createProductCategoryFailure)))))

  updateProductCategory$ = createEffect(() => this.actions$.pipe(
    ofType(updateProductCategory),
    tap(() => this.toaster.progress('Updating product category...')),
    switchMap(action =>
      from(this.ProductCategories.update({ ...action.productCategory, category_id: action.id })).pipe(
        map(productCategory => updateProductCategorySuccess({ productCategory })),
        tap(() => this.toaster.success('Product category updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update product category', updateProductCategoryFailure)))))
}
